import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hello, I'm Ammar Jabakji - Full-Stack & AI Engineer.`}</h1>
    <p>{`Experienced Full-Stack Engineer with 15+ years of building and scaling production web and mobile applications across diverse industries. Today, my focus is on developing AI-native products and intelligent business platforms that combine modern software engineering with large language models (LLMs) and automation.`}</p>
    <p>{`I design, architect, and deliver end-to-end solutions using React, Next.js, React Native, Node.js, SQL, and cloud-native technologies. I leverage AI tools daily—including Claude Code and ChatGPT—to accelerate research, system design, development, testing, and documentation, enabling faster delivery without compromising code quality or maintainability.`}</p>
    <p>{`Throughout my career, I have led projects from concept to production, building scalable architectures, integrating complex APIs, optimizing performance, and creating intuitive user experiences. I enjoy solving ambiguous, high-impact problems and taking ownership of products throughout their entire lifecycle.`}</p>
    <p>{`Beyond software engineering, I have strong expertise in digital marketing, SEO, AI-powered workflows, and business automation. This combination allows me to build products that are not only technically robust but also focused on user growth, discoverability, and measurable business outcomes.`}</p>
    <p>{`I am particularly passionate about AI applications, intelligent automation, B2B platforms, developer productivity, and creating software that helps businesses operate more efficiently. I thrive in fast-paced environments where technology, product strategy, and innovation intersect.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      